<div class="container">
  <div class="booking-body">
    <ng-container *ngIf="isMobile">
      <ng-container *ngTemplateOutlet="hotelDetailSegment"></ng-container>
      <!-- Temporarily Disabled -->
      <ng-container *ngIf="false">
        <ng-container *ngTemplateOutlet="marriottWelcomeBanner"></ng-container>
      </ng-container>
      <!-- / Temporarily Disabled -->
    </ng-container>
    <ng-container class="body-hotels-booking">
      <form *ngIf="user" [formGroup]="bookingHotelsForm" class="booking-form-info hotels">
        <section class="pax-section-cont">
          <ng-container *ngFor="let room of guestListUI$ | async; index as roomIndex">
            <div class="title">
              <app-ds-typography
                [tag]="'h3'"
                [size]="fontSize.XS"
                [color]="fontColor.Primary"
                [fontFamily]="fontFamily.SemiBold"
                [text]="
                  ('BOOKING_MODULE.PAX.ROM_PAX_GUESTS' | transloco) +
                  ' - ' +
                  ('BOOKING_MODULE.PAX.ROOM_PAX_NUMER' | transloco: { room: room.roomNumber })
                ">
              </app-ds-typography>
            </div>
            <div class="description">
              <app-ds-typography
                [tag]="'p'"
                [size]="fontSize.XXS"
                [color]="fontColor.Secondary"
                [fontFamily]="fontFamily.Regular"
                [text]="'BOOKING_MODULE.PAX.ROOM_DESCRIPTION' | transloco">
              </app-ds-typography>
            </div>
            <div class="room-guest-list-cont">
              <ng-container *ngFor="let guestUI of room.roomGuests | slice : 0 : 1; index as guestIndex">
                <app-pax-section
                  [validator]="hotelValidation"
                  [countries]="countries$ | async | countriesVm"
                  [travelerType]="guestUI.TravelerType"
                  [listUILength]="room.roomGuests.length"
                  [travelerInfoType]="guestUI.TravelerInfoType"
                  [paxTravelers]="travelers$ | async | travelerListVm : guestUI.TravelerType : guestUII(roomIndex, guestIndex) : startDate | async"
                  [ordinalKey]="guestUI.OrdinalKey"
                  [ordinalNumber]="guestUI.OrdinalNumber"
                  [defaultData]="guestUI.defaultData"
                  [form]="bookingHotelsForm"
                  [user]="user"
                  [isSubmittedSuccess]="isSubmittedSuccess"
                  [isSubmitted]="isSubmitted"
                  [isLoadingPaxForm]="isLoadingPaxForm$ | async"
                  [travelerNumber]="roomIndex"
                  [isMobile]="isMobile"
                  [travelerAge]="childrenAge(roomIndex, guestUI.IndexTypeNumber, guestUI.TravelerType)"
                  [travelerBookingProvider]="travelerBookingProvider"
                  [businessRules]="businessRules$ | async"
                  [isAnInternationalTrip]="isAnInternationalTrip$ | async"
                  [bookingSource]="hotelValidation?.HotelReservation?.BookingSource"
                  [marriottloyaltyNumber]="marriottloyaltyNumber$ | async"
                  [marriottCreatedAccount]="marriottCreatedAccount$ | async"
                  [marriottCreateAccountShowStatus]="marriottCreateAccountShowStatus$ | async"
                  [isLoadingMarriottCreateForm]="isLoadingMarriottCreateForm$ | async"
                  (selectPax)="selectTravelerPax($event, roomIndex, guestIndex)"
                  (removePax)="deleteTravelerPax($event, roomIndex, guestIndex)"
                  (createPax)="createTravelerPax($event, bookingHotelsForm, { id: roomIndex, TravelerInfoType: guestUI.TravelerInfoType, guestId: guestIndex }, startDate)"
                  (updatePax)="updateTravelerPax($event, bookingHotelsForm, { id: roomIndex, TravelerInfoType: guestUI.TravelerInfoType, guestId: guestIndex })"
                  (amplitudeEvent)="trackBookingAmplitudeEvent($event, travelerBookingProvider)"
                  (createMarriottBonvoyAccount)="createMarriottBonvoyAccount($event)"
                  (resetMarriottCreateAccountShowStatus)="resetMarriottCreateAccountShowStatus()">
                </app-pax-section>
              </ng-container>
            </div>
          </ng-container>
        </section>
        <ng-container *ngIf="paxSectionReady">
          <section *ngIf="activeBillingModule" #sectionBillingRef>
            <ng-container *ngTemplateOutlet="billingSectionTemplate"></ng-container>
          </section>
          <section class="contact-info-cont" #sectionContactDetails>
            <app-contact-section
              [form]="bookingHotelsForm"
              [isSubmitted]="isSubmitted"
              [isMobile]="isMobile"
              [user]="user">
            </app-contact-section>
          </section>
          <section #sectionAdditionalInformation>
            <app-additional-information
              [form]="bookingHotelsForm"
              [isHidden]="true"
              [isSubmitted]="isSubmitted">
            </app-additional-information>
          </section>
          <section>
            <app-policies-detail
              [policiesType]="policiesType"
              [isMobile]="isMobile"
              [hotelValidation]="hotelValidation"
              [isBookingView]="true">
            </app-policies-detail>
          </section>
          <app-fare-info [textFare]="hotelValidation?.TextFare"></app-fare-info>
          <section class="content-banner">
            <ng-container *ngTemplateOutlet="chubbBookingBanner"></ng-container>
          </section>
          <section class="terms-cont" #sectionPaymentDetail *ngIf="isMobile">
            <app-hotel-payment-detail
              [text]="hotelValidation?.TextFare"
              [conversionRate]="conversionRate$ | async"
              [amount]="hotelValidation?.Amount"
              [guestsPerRoom]="guestsPerRoomState$ | async"
              [pricePerNights]="pricePerNights"
              [nights]="nights"
              [isByhours]="hotelValidation?.HotelReservation?.MicroStay"
              [hours]="hoursMicroStay"
              [capacity]="capacityMicroStay"
              [isMobile]="isMobile">
            </app-hotel-payment-detail>
          </section>
          <section class="terms-cont" #sectionTermsRef>
            <app-terms-and-conditions
              [form]="bookingHotelsForm"
              [isSubmitted]="isSubmitted">
            </app-terms-and-conditions>
          </section>
        </ng-container>
        <section *ngIf="applyConversion$ | async">
          <app-exchange-rate-info 
            [conversionRate]="conversionRate$ | async">
          </app-exchange-rate-info>
        </section>
        <section *ngIf="activeCallSupportModule">
          <app-support-info></app-support-info>
        </section>
        <app-btn-go-to-pay
          [isMobile]="isMobile"
          [disabled]="(bookingReady$ | async) === false"
          [isLoadingBooking]="isLoadingBookingDelay"
          [applyConversion]="applyConversion$ | async"
          [conversionRate]="conversionRate$ | async"
          [finalPrice]="hotelValidation?.Amount?.Total"
          [currencyCode]="hotelValidation?.Amount?.CurrencyCode"
          [productReference]="hotelValidation.HotelReservation.ProductReference"
          (goToPay)="submitBookingOptions($event)">
        </app-btn-go-to-pay>
      </form>
    </ng-container>
    <ng-container *ngIf="!isMobile">
      <div class="booking-payment-detail">
        <div class="payment-detail-cont">
          <ng-container *ngTemplateOutlet="paymentDetail"></ng-container>
          <!-- Temporarily Disabled -->
          <ng-container *ngIf="false">
            <ng-container *ngTemplateOutlet="marriottWelcomeBanner"></ng-container>
          </ng-container>
          <!-- / Temporarily Disabled -->
          <ng-container *ngTemplateOutlet="hotelDetailBody"></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #paymentDetail>
  <app-hotel-payment-detail
    [text]="hotelValidation?.TextFare"
    [guestsPerRoom]="guestsPerRoomState$ | async"
    [amount]="hotelValidation?.Amount"
    [conversionRate]="conversionRate$ | async"
    [pricePerNights]="pricePerNights"
    [nights]="nights"
    [isMobile]="isMobile"
    [isByhours]="hotelValidation?.HotelReservation?.MicroStay"
    [hours]="hoursMicroStay"
    [capacity]="capacityMicroStay"
    [productReference]="hotelValidation?.HotelReservation?.ProductReference">
  </app-hotel-payment-detail>
</ng-template>

<ng-template #hotelDetailBody>
  <app-hotel-reservation
    [image]="hotelValidation?.HotelReservation?.Hotel?.Thumbnail"
    [hotelName]="hotelValidation?.HotelReservation?.Hotel?.HotelName"
    [stars]="hotelValidation?.HotelReservation?.Hotel?.Category"
    [destinationName]="hotelValidation?.HotelReservation?.DestinationName"
    [location]="hotelValidation?.HotelReservation?.Hotel?.FullAddress"
    [checkin]="hotelValidation?.HotelReservation?.Checkin"
    [checkout]="hotelValidation?.HotelReservation?.Checkout"
    [rooms]="hotelValidation?.HotelReservation?.Rooms"
    [provider]="hotelValidation.HotelReservation?.BookingSource">
  </app-hotel-reservation>
</ng-template>

<ng-template #hotelDetailSegment>
  <ng-container *ngIf="hotelValidation?.HotelReservation as hotelReservation">
    <app-hotel-segment-detail
      (showHotelDetail)="showHotelDetail()"
      [capacity]="capacityMicroStay"
      [hotelReservation]="hotelReservation">
    </app-hotel-segment-detail>
  </ng-container>
</ng-template>

<ng-template #billingSectionTemplate>
  <ng-container *ngIf="billingModuleIsOptional; else billingModuleTemplate">
    <ng-container *ngTemplateOutlet="optinalBillingModuletemplate"></ng-container>
  </ng-container>

  <ng-template #optinalBillingModuletemplate>
    <app-optional-billing-box
      [showBillingModule]="showBillingModule"
      (setShowBillingModule)="setShowBillingModule($event)">
    </app-optional-billing-box>
    <ng-container *ngTemplateOutlet="billingModuleTemplate; context: { hiddenHeader: true }"></ng-container>
  </ng-template>
  
  <ng-template #billingModuleTemplate let-hiddenHeader='hiddenHeader'>
    <ng-container *ngIf="showBillingModuleData">
      <app-billing
        [isSubmitted]="isSubmitted"
        [bookingForm]="bookingHotelsForm"
        [countries]="countries$ | async | countriesVm"
        [cities]="cities$ | async"
        [user]="user"
        [isMobile]="isMobile"
        [showHeaderInfo]="!hiddenHeader"
        [byHotels]="true">
      </app-billing>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #chubbBookingBanner let-isPayment="isPayment">
  <ng-container *ngIf="!!hasTravelerInfoList">
    <app-chubb-booking-banner
      [bookingType]="travelerBookingProvider"
      [travelers]="travelerInfoList?.length"
      [days]="nights"
      [isInternationalTrip]="isAnInternationalTrip$ | async"
      [isPayment]="!!isPayment"
      [assistanceInfo]="assistanceSearchInfo$ | async"
      [isActivateFreeChubbAssistance]="isActivateFreeChubbAssistance$ | async"
      [isPrimeUser]="isPrimeUser$ | async"
      (showPaymentOfferDetails)="setShowAssistanceDetails(true)">>
    </app-chubb-booking-banner>
  </ng-container>
</ng-template>

<ng-template #marriottWelcomeBanner>
  <app-marriott-welcome-banner
    [isPrime]="isPrimeUser$ | async"
    [bookingSource]="hotelValidation?.HotelReservation?.BookingSource"
    [activeBonvoyNumber]="activeBonvoyNumber$ | async">
  </app-marriott-welcome-banner>
</ng-template>

<app-travel-assistance
  [bookingType]="travelerBookingProvider"
  [isMobile]="isMobile"
  [showAssistanceInfo]="showAssistanceInfo$ | async"
  [assistanceInfo]="assistanceSearchInfo$ | async"
  [totalPrice]="hotelValidation?.Amount?.Total"
  [isLoading]="isLoadingBookingDelay"
  [showDetailInfo]="showAssistanceDetails$ | async"
  [applyConversion]="applyConversion$ | async"
  [conversionRate]="conversionRate$ | async"
  
  (hiddenAssistanceDetails)="setShowAssistanceDetails(false)"
  (payButtonEvent)="submitBookingOptionsByAssistance(bookingHotelsForm.value, $event)"
  (exitEvent)="closeAssistanceInfo()"
  
  (amplitudeTrigger)="trackBookingAmplitudeEvent($event, travelerBookingProvider)">
  <ng-container assistanceBanner>
    <ng-container *ngTemplateOutlet="chubbBookingBanner; context: { isPayment: true }"></ng-container>
  </ng-container>
</app-travel-assistance>

<router-outlet name="hotel-detail"></router-outlet>

